import { createSlice } from "@reduxjs/toolkit";
import { FirebaseError } from "firebase/app";
import { FirestoreService } from "../../api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../api/firebase/references";
import { FormOptionsModel } from "../../data-model/formOptions";
import { logError } from "../../utils/customLogger";
import { AppDispatch } from "../store/store";

interface FormOptionsModelSlice {
  data?: FormOptionsModel[];
  loading: boolean;
  error: string | null;
}

const initialState: FormOptionsModelSlice = {
  data: undefined,
  loading: false,
  error: null,
};

const formOptionsSlice = createSlice({
  name: "formOptionsSlice",
  initialState,
  reducers: {
    fetchFormOptionsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchFormOptionsSuccess(state, action) {
      state.data = action.payload;
      state.loading = false;
    },
    fetchFormOptionsFailure(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    resetFormOptions(state) {
      state.data = undefined;
      state.loading = false;
      state.error = null;
    },
  },
});

export const { resetFormOptions } = formOptionsSlice.actions;

export const fetchAllFormOptionsFromFirebase = () => {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch(formOptionsSlice.actions.fetchFormOptionsStart());
    try {
      const formOptions = await FirestoreService.getAllDocuments(
        FirestoreCollectionReference.formOptions(),
      );
      dispatch(formOptionsSlice.actions.fetchFormOptionsSuccess(formOptions));
    } catch (error) {
      const firebaseError = error as FirebaseError;

      logError(firebaseError, "Error fetching form options");
      dispatch(
        formOptionsSlice.actions.fetchFormOptionsFailure(firebaseError.message),
      );
    }
  };
};

export default formOptionsSlice.reducer;
